import { useMemo } from "react";
import { useSelector } from "react-redux";
import { AppState } from "@Store/index";

const EMPTY: string[] = [];

/** SEO (PLG-3406): noindexed slugs linked from this page, set by its data loader. */
const useNoindexSlugs = (): Set<string> => {
  const noindexSlugs = useSelector(({ appData }: AppState) => appData?.noindexSlugs || EMPTY);
  return useMemo(() => new Set(noindexSlugs), [noindexSlugs]);
};

export default useNoindexSlugs;
